import api from '../config/api';
import {
  MemberPetition,
  CreatePetitionRequest,
} from '../types/petition';
import { normalizeMemberPetition } from '../utils/petition';

export const memberPetitionService = {
  getMyPetitions: async (): Promise<MemberPetition[]> => {
    const response = await api.get<MemberPetition[]>('/members/me/petitions');
    return (response.data ?? []).map(normalizeMemberPetition);
  },

  getMyPetitionById: async (id: string): Promise<MemberPetition | null> => {
    try {
      const response = await api.get<MemberPetition>(`/members/me/petitions/${id}`);
      return normalizeMemberPetition(response.data);
    } catch (err: unknown) {
      if ((err as { response?: { status?: number } })?.response?.status === 404) {
        return null;
      }
      throw err;
    }
  },

  createPetition: async (body: CreatePetitionRequest): Promise<MemberPetition> => {
    const response = await api.post<MemberPetition>('/members/me/petitions', body);
    return normalizeMemberPetition(response.data);
  },
};
